import React from 'react';
import styled from 'styled-components';
import appInfoContainer from 'auth/appInfoContainer'
import { formatCommentDate } from 'utils/utils';
import DotButton from 'components/presenters/button/DotButton';

export default function FeedCommentReply({replyItem, userInfo, handleReplyDeleteBottomModal}) {
    return (
        <ReplyItemBlock>
            <UserProfileImgBlock>
                <UserProfileImg src={`${appInfoContainer.imagePath}/user_profile_img/${replyItem['profile_img']}`}/>
            </UserProfileImgBlock>
            <ReplyInfoBlock>
                <UserName>{replyItem['nickname']}</UserName>
                <ReplyText>{replyItem['content']}</ReplyText>
                <ReplyBottomBlock>
                    <ReplyTime>{formatCommentDate(replyItem['create_date'])}</ReplyTime>
                </ReplyBottomBlock>
            </ReplyInfoBlock>
            {userInfo['id'] === replyItem['user_no'] || userInfo['role'] === 'admin' ? <DotButton onClick={() => handleReplyDeleteBottomModal(replyItem)}/> : null}
        </ReplyItemBlock>
    );
}

const ReplyItemBlock = styled.div`
    display: flex;
    margin-top: calc(100vw * (20 / 375));
`;

const UserProfileImgBlock = styled.div`
    width: calc(100vw * (22 / 375));
    height: calc(100vw * (22 / 375));
    border-radius: 50%;
    overflow: hidden;
    border: solid calc(100vw * (1 / 375)) #c6c6c6;
`;

const UserProfileImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;`
;

const ReplyInfoBlock = styled.div`
    width: 100%;
    margin-left: calc(100vw * (10 / 375));
`;

const UserName = styled.span`
    font-size: calc(100vw * (14 / 375));
    font-weight: 500;
    color: #1d1d1d;
    margin-right: calc(100vw * (5 / 375));
`;

const ReplyText = styled.span`
    font-size: calc(100vw * (14 / 375));
    color: #1d1d1d;
    white-space: pre-wrap;
    word-break: break-all; 
`;

const ReplyBottomBlock = styled.div`
    display: flex; 
`;

const ReplyTime = styled.p`
    font-size: calc(100vw * (12 / 375));
    line-height: 1.55;
    color: #989898;
`;


